import { FieldValues, Path, useFormContext } from 'react-hook-form';
import { FormItem, FormField } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { Label } from './ui/label';

interface FormFieldComponentProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  disabled?: boolean;
}

const FormFieldTextArea = <T extends FieldValues>({
  name,
  label,
  placeholder,
  required,
  className,
  onChange,
  rows,
  disabled,
}: FormFieldComponentProps<T>): JSX.Element => {
  const { control } = useFormContext();
  return (
    <FormItem className="flex flex-col gap-1">
      <Label htmlFor={name} className="block text-sm font-medium">
        {label}
        {required && <span className="text-error align-top">*</span>}
      </Label>
      <FormField
        control={control}
        name={name}
        render={({ field, fieldState }) => (
          <>
            <Textarea
              {...field}
              id={name}
              value={field.value ?? ''}
              onChange={(e) => {
                if (onChange) {
                  onChange(e);
                }
                if (e.target.value.length === 0 || !e.target.value) field.onChange(null);
                else field.onChange(e);
              }}
              rows={rows}
              placeholder={placeholder}
              disabled={disabled}
              className={`bg-white resize-none ${className ?? ''}`}
            />
            {fieldState.error && <p className="text-error text-xs">{fieldState.error.message}</p>}
          </>
        )}
      />
    </FormItem>
  );
};

export default FormFieldTextArea;
